// Listing filters (Work page) — progressive enhancement, mirrors the RFP
// portal board. The form is a plain GET form and works without this.
document.querySelectorAll('[data-filters]').forEach((form) => {
	const wrap = form.closest('.filter');
	const flag = 'e23-filters-scroll';

	// Remember to bring the filters back into view after the reload,
	// without putting a #hash on the URL.
	const rememberScroll = () => {
		try { sessionStorage.setItem(flag, '1'); } catch (e) {}
	};

	// Build the URL ourselves so empty params are dropped and there's
	// no bare "?" when every filter is cleared (/work/ not /work/?).
	const go = () => {
		const url = new URL(form.action, window.location.href);
		const params = new URLSearchParams();

		new FormData(form).forEach((value, key) => {
			value = String(value).trim();
			if (value) params.append(key, value);
		});

		url.search = params.toString();
		url.hash = '';

		rememberScroll();
		window.location.assign(url.toString());
	};

	form.addEventListener('submit', (e) => {
		e.preventDefault();
		go();
	});

	// Apply selects as soon as they change
	form.querySelectorAll('[data-filters-autosubmit]').forEach((el) => {
		el.addEventListener('change', go);
	});

	if (!wrap) return;

	// "Clear filters" goes to the plain page URL; just keep the scroll spot
	wrap.querySelectorAll('[data-filters-clear]').forEach((link) => {
		link.addEventListener('click', rememberScroll);
	});

	// Coming back from a filter change: jump to the filters
	let scroll = false;
	try {
		scroll = sessionStorage.getItem(flag) === '1';
		sessionStorage.removeItem(flag);
	} catch (e) {}

	if (scroll) {
		wrap.scrollIntoView({ block: 'start', behavior: 'instant' });
	}
});